import React from 'react';
export const RecommendContext = /*#__PURE__*/React.createContext({
  hasProvider: false
});
if (process.env.NODE_ENV !== 'production') {
  RecommendContext.displayName = 'Recommend';
}
export const useRecommendContext = () => React.useContext(RecommendContext);
export const useRecommendClient = recommendClient => {
  const context = React.useContext(RecommendContext);
  if (recommendClient) {
    return {
      client: recommendClient,
      isContextClient: false
    };
  }
  if (context.recommendClient) {
    return {
      client: context.recommendClient,
      isContextClient: true
    };
  }
  throw new Error(
  // To do work on error message
  'Pass an Algolia `recommendClient` instance either to the Recommend React context, a component or hook.');
};